import Vue from "vue";
import router from "@/router";
import { Loading, Message, MessageBox, Notification } from "element-ui";
import { ipAutoLogin, login, logout } from "@/servers/api";
import { saveIpAutoLoginToken } from "@/utils/ipAutoLogin";

const newLoading = () => {
  return Loading.service({
    lock: true,
    text: "拼命加载中，请稍等……",
    target: document.body,
  });
};
const user = {
  state: {
    token: "",
  },
  // 对数据加工，并返回
  getters: {},
  // 用作state数据修改
  mutations: {
    SET_TOKEN: (state, data) => {
      Vue.ls.set("ACCESS_TOKEN", data.token);
      state.token = data.token;
    },
    SET_IP_TOKEN: (state, token) => {
      state.token = token;
    },
    CLEAR_USER: (state, payload = {}) => {
      Vue.ls.clear();
      state.token = "";
      if (payload.redirect !== false) {
        router.push("/login");
      }
    },
  },
  // 异步修改数据
  actions: {
    ipAutoLogin({ commit, dispatch }) {
      return ipAutoLogin().then((res) => {
        if (!res || res.code !== 200 || !res.success || !res.result || !res.result.token) {
          return false;
        }
        if (!saveIpAutoLoginToken(res.result.token)) {
          return false;
        }
        commit("SET_IP_TOKEN", res.result.token);
        return dispatch("app/initializeAfterLogin", null, { root: true })
          .then(() => true)
          .catch(() => {
            Vue.ls.remove("ACCESS_TOKEN");
            commit("SET_IP_TOKEN", "");
            return false;
          });
      }).catch(() => false);
    },
    loginMethod({ commit, dispatch }, infor) {
      return new Promise((resolve, reject) => {
        login(infor)
          .then((res) => {
            if (res.code === 200 && res.success) {
              commit("SET_TOKEN", { token: res.result.token, userInfo: res.result.userInfo });
              Vue.ls.set("USER_INFO", res.result.userInfo);
              dispatch("app/initializeAfterLogin", null, { root: true }).catch(
                () => { }
              );
              Message.success({
                message: "欢迎您，" + res.result.userInfo.username,
                duration: 1000
              });
              if (res.result.passwordNeedUpdate) {
                Notification({
                  title: "安全提示",
                  message: "为了您的密码使用安全，请定期修改。",
                  type: "warning",
                  position: "top-right",
                  duration: 8000,
                });
              }
              const redirectPath =
                (router.currentRoute && router.currentRoute.query && router.currentRoute.query.redirect) ||
                "/home";
              router.push(redirectPath);
              resolve(res);
            } else {
              dispatch("permission/ResetPermission", null, { root: true });
              dispatch("app/resetAfterLogout", null, { root: true });
              commit("CLEAR_USER");
              Message.error(res.message);
              reject();
            }
          })
          .catch(() => {
            dispatch("permission/ResetPermission", null, { root: true });
            dispatch("app/resetAfterLogout", null, { root: true });
            commit("CLEAR_USER");
            reject();
          });
      });
    },
    exitLogin({ commit, dispatch }) {
      MessageBox.confirm("此操作将退出系统, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let isLoad = newLoading();
          // 1. 先调后端 logout，让后端清理 Redis：userToken、shiroAuth、sys:cache:user
          // 2. 不论后端成功失败，finally 都清理前端本地凭证和运行时状态
          logout()
            .catch((err) => {
              console.warn("[fb] 后端 logout 失败，仍清理前端 session", err);
            })
            .finally(() => {
              dispatch("permission/ResetPermission", null, { root: true });
              dispatch("app/resetAfterLogout", null, { root: true });
              commit("CLEAR_USER");
              isLoad.close();
              Message.success("您已安全退出平台，感谢您的使用");
            });
        })
        .catch(() => {
          Message({
            type: "info",
            message: "您已取消操作",
          });
        });
    },
  },
  //使其成为带命名空间的模块。保证在变量名一样的时候，添加一个父级名拼接。
  namespaced: true,
};

export default user;
